import exchangeModule from './modules/exchange';
import accommodationModule from './modules/accommodation';
import adminReservationModule from './modules/adminReservation';
import filterModule from './modules/filter';
import restrictionModule from './modules/externalIcal';
import searchModule from './modules/search';
import searchQueryModule from './modules/searchQuery';
import simulatorModule from './modules/simulator';
import reservationModule from './modules/reservation';
import appVersionCheckModule from "@/store/modules/appVersionCheck";
import bankDataModule from "@/store/modules/bankData";
import userModule from "@/store/modules/user";
import conversationsModule from "./modules/conversations";
import notificacionesModule from "./modules/notificaciones";

export default {
    exchange: exchangeModule,
    accommodation: accommodationModule,
    adminReservation: adminReservationModule,
    filter: filterModule,
    restriction: restrictionModule,
    search: searchModule,
    searchQuery: searchQueryModule,
    simulator: simulatorModule,
    reservationNew: reservationModule,
    appVersionCheck: appVersionCheckModule,
    bankData: bankDataModule,
    userNew: userModule,
    conversations: conversationsModule,
    notificaciones: notificacionesModule
};